import React, { useState } from "react";
import { Info, X, Check } from "lucide-react";

export default function InfoBanner({
  title,
  description,
  capabilities = [],
  docsUrl,
}) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className="relative flex flex-col sm:flex-row gap-0 rounded-lg border border-gray-200 bg-white overflow-hidden">
      {/* Left blue accent bar */}
      <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-blue-600" />

      {/* Left: title + description + docs */}
      <div className="flex-1 min-w-0 pl-6 pr-4 py-4">
        <div className="flex items-center gap-1.5 mb-1">
          <Info className="h-3.5 w-3.5 text-blue-600 shrink-0" />
          <span className="text-[11px] font-semibold uppercase tracking-widest text-blue-600">
            Help Guide
          </span>
        </div>
        <h3 className="text-sm font-semibold text-gray-900 mb-1">{title}</h3>
        <p className="text-[13px] text-gray-500 leading-relaxed">
          {description}
        </p>
        {docsUrl && (
          <a
            href={docsUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-3 inline-flex items-center gap-1 rounded border border-gray-300 bg-white px-3 py-1 text-xs font-medium text-gray-600 hover:bg-gray-50 transition-colors"
          >
            Read docs
          </a>
        )}
      </div>

      {/* Divider */}
      {capabilities.length > 0 && (
        <div className="hidden sm:block w-px bg-gray-100 my-4" />
      )}

      {/* Right: capabilities */}
      {capabilities.length > 0 && (
        <div className="flex-1 min-w-0 px-5 py-4">
          <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 mb-2">
            Key capabilities:
          </p>
          <ul className="space-y-1.5">
            {capabilities.map((cap, i) => (
              <li
                key={i}
                className="flex items-start gap-2 text-[13px] text-gray-600"
              >
                <Check className="h-3.5 w-3.5 text-blue-500 shrink-0 mt-0.5" />
                {cap}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Dismiss */}
      <button
        onClick={() => setDismissed(true)}
        className="absolute bg-transparent right-3 top-3 p-1 text-gray-500 hover:text-gray-800 transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
